import { DATE_FORMAT_RU } from 'constants/date';
import { DUMMY_ACCESS_RULES, mapEntityParams } from 'constants/entities';
import { Geometry, Position } from 'geojson';
import { PredefinedTemplate } from 'types';

import {
  createInitialMapEntity,
  getFormattedDate,
  getInitialMapObject,
} from 'utils';

export const createMapObject = (
  mapObjectTemplate: PredefinedTemplate,
  mapLayerTemplate: PredefinedTemplate,
  paramIdMap: Record<string, any>,
  parentEntityId: number,
  geometry: Geometry
) => {
  const entity = getInitialMapObject(
    0,
    mapObjectTemplate.template.id,
    paramIdMap,
    geometry,
    parentEntityId
  );

  const mapEntity = createInitialMapEntity(
    mapLayerTemplate.template.id,
    mapObjectTemplate.template.id,
    entity,
    DUMMY_ACCESS_RULES,
    parentEntityId
  );

  mapEntity.state.draft = true;
  mapEntity.state.active = true;

  return mapEntity;
};

export const createQuickMapObject = (
  mapObjectTemplate: PredefinedTemplate,
  mapLayerTemplate: PredefinedTemplate,
  paramIdMap: Record<string, any>,
  position: Position,
  type: string,
  parentId: number
) => {
  const mapEntity = createMapObject(
    mapObjectTemplate,
    mapLayerTemplate,
    paramIdMap,
    parentId,
    { type: 'Point', coordinates: position }
  );

  mapEntity.entity.title = `${type}, ${getFormattedDate(
    mapEntity.entity.parameters[paramIdMap[mapEntityParams.DATE]].value,
    DATE_FORMAT_RU
  )}`;
  mapEntity.entity.parameters[paramIdMap[mapEntityParams.TYPE]] = {
    value: type,
  };

  return mapEntity;
};
